'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const EventDialogStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventDialogStyledContext.displayName = "EventDialogStyledContext";
export function useEventDialogStyledContext() {
  const value = React.useContext(EventDialogStyledContext);
  if (!value) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useEventDialogStyledContext must be used within an EventDialogStyledContext.Provider. ' + 'The component requires access to dialog styling and locale information. ' + 'Ensure the component is rendered inside an EventDialog component.' : _formatErrorMessage(207));
  }
  return value;
}